<template>
    <b-modal id="modal-approver" ref="approverModalComponent" :ok-only="true" :ok-title="$t('core.close')"
           :title="$t('sandoz.approver_details')" size="xl" @close="hideDialog">
        <template v-if="contract && contract.next_approver">
            <div class="row justify-content-start pb-1 pt-1 font-weight-bold ml-1 mr-1">
                <div v-for="n in 6" class="col-sm pb-1 pl-0 mt-2">
                    <div v-if="('approver_' + '' + n) in contract && contract['approver_' + '' + n] && contract.next_approver >= n">
                        {{ $t('sandoz.approver_no', { number: n }) }}
                    </div>
                    <div class="font-weight-normal mb-3" v-if="contract.next_approver >= n && ('approver_' + '' + n) in contract && contract['approver_' + '' + n]">
                        <div>{{ contract['approver_' + '' + n] }}</div>
                        <div v-if="contract.next_approver == n && !contract.is_approved">
                            <span class="badge badge-danger" >{{ $t('sandoz.pending') }}</span>
                        </div>
                        <template v-else>
                            <div v-if="('approval_date_' + '' + n) in contract && contract['approval_date_' + '' + n] && contract['approval_date_' + '' + n] !== '0000-00-00'">
                              {{ contract['approval_date_' + '' + n] | formatDate }}
                            </div>
                            <div v-if="('approval_person_' + '' + n) in contract && contract['approval_person_' + '' + n]">
                              {{ contract['approval_person_' + '' + n] }}
                            </div>
                        </template>
                    </div>
                </div>
            </div>
            <template v-if="!contract.is_approved">
                <div class="pl-0 pr-0 font-weight-bold">
                    {{ $t('sandoz.next_approver_users', {role: contract.next_approver_role}) }} <span class="badge badge-info" >{{ $t('sandoz.next_approver') }}</span>
                </div>
                <div class="row justify-content-start pb-1 pt-1 font-weight-bold ml-1 mr-1 mt-3">
                    <div class="col-sm pb-1 pl-0">
                        {{$t('core.name')}}
                    </div>
                    <div class="col-sm pb-1 pl-0 pr-0">
                        {{$t('core.email')}}
                    </div>
                    <div class="col-sm pb-1 pl-0 pr-0">
                        {{$t('core.phone')}}
                    </div>
                    <div class="col-sm pb-1 pl-0 pr-0">
                        {{$t('core.status')}}
                    </div>
                </div>
                <template v-if="contract.next_approver_users && contract.next_approver_users.data && Object.keys(contract.next_approver_users.data).length">
                    <div class="row justify-content-start border-top pb-1 pt-1 ml-1 mr-1" v-for="user in contract.next_approver_users.data.filter(u => contract.status !== 'Draft' || u.active)">
                        <div class="col-sm pb-1 pl-0">
                            {{ user.name }}
                        </div>
                        <div class="col-sm pb-1 pl-0 pr-0">
                            {{ user.email }}
                        </div>
                        <div class="col-sm pb-1 pl-0 pr-0">
                            {{ user.phone }}
                        </div>
                        <div class="col-sm pb-1 pl-0 pr-0">
                            <span class="badge" :class="user.active ? 'badge-success': 'badge-danger'">
                                {{ user.active ? $t('core.active') : $t('core.inactive') }}
                            </span>
                        </div>
                    </div>
                </template>
                <template v-else>
                    <div class="row justify-content-start border-top pb-1 pt-1 ml-1 mr-1">
                        <div class="col-sm pb-1 pl-0">
                            {{ $t('sandoz.approver_not_found') }}
                        </div>
                    </div>
                </template>
            </template>
        </template>
        <template v-else>
            <div class="row justify-content-start pb-1 pt-1 ml-1 mr-1">
                <div class="col-sm pb-1 pl-0">
                    {{ $t('sandoz.not_need_to_approve') }}
                </div>
            </div>
        </template>
  </b-modal>
</template>

<script>
  export default {
    props: [
      'contract'
    ],
    data: () => ({
    }),
    methods: {
      showDialog() {
        this.$refs.approverModalComponent.show()
      },
      hideDialog() {
        this.$refs.approverModalComponent.hide()
      }
    }
  }
</script>
